import { lighten, radioClasses, svgIconClasses, type Theme } from '@mui/material';
import { ToggleButtonStyle } from 'components/lib/ToggleButton/ToggleButton.styles';
import type { StyleExtend } from 'providers/theme/theme.types';

export const PaymentOptionSelectStyle: StyleExtend<Theme> = {
  width: '100%',
  gap: '1rem',
};

export const PaymentOptionSelectToggleStyle: StyleExtend<Theme> = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridAutoRows: '1fr',
  gap: '1rem',
};

export const PaymentOptionSelectButtonStyle: StyleExtend<Theme> = {
  ...ToggleButtonStyle,
  gap: '.75rem 1rem',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: (theme) => `${theme.palette.customColors.white50}`,
  color: (theme) => theme.palette.customColors.gunMetal,

  [`.${radioClasses.root}`]: {
    position: 'absolute',
    fontSize: '2rem !important',

    [`.${svgIconClasses.root}`]: {
      fontSize: 'inherit',
    },
  },
};

export const PaymentOptionSelectHeaderStyle: StyleExtend<Theme> = {
  direction: 'row',
  gap: '1rem',
  width: '100%',
};

export const PaymentOptionSelectTitleStyle: StyleExtend<Theme> = {
  textAlign: 'center',
  width: '100%',
  color: (theme) => theme.palette.customColors.gunMetal,
};

export const PaymentOptionSelectTitleValueStyle: StyleExtend<Theme> = {
  fontWeight: '900',
};

export const PaymentOptionSelectDetailsListStyle: StyleExtend<Theme> = {
  width: '100%',
  gap: '.5rem',
};

export const PaymentOptionSelectDetailStyle: StyleExtend<Theme> = {
  display: 'flex',
  gap: '1rem',
  justifyContent: 'space-between',
  color: (theme) => theme.palette.customColors.gunMetal,
};

export const PaymentOptionSelectNoteStyle: StyleExtend<Theme> = {
  padding: '1.25rem 2.5rem',
  color: (theme) => theme.palette.customColors.success,
  border: (theme) => `1px solid ${lighten(`${theme.palette.customColors.success}`, 0.5)}`,
  backgroundColor: (theme) => lighten(`${theme.palette.customColors.success}`, 0.95),
  borderRadius: '4px',
  marginInline: '.75rem',
  textAlign: 'center',
};
